var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9513",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10451"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 39299",
    d: "M26.569 12.331V14.2c-.058.426-.1.854-.177 1.278a13 13 0 0 1-2.751 6.111 13.073 13.073 0 0 1-7.987 4.746c-.473.087-.952.141-1.429.21h-1.867c-.075-.017-.149-.039-.225-.05-.529-.076-1.064-.119-1.586-.229A13.3 13.3 0 0 1 .132 11.424a12.6 12.6 0 0 1 2.382-5.911A13.043 13.043 0 0 1 14.708.061a12.339 12.339 0 0 1 6.263 2.368 13.087 13.087 0 0 1 5.391 8.5c.086.465.139.935.207 1.4M13.284 2.06a11.2 11.2 0 1 0 11.21 11.2 11.221 11.221 0 0 0-11.21-11.2",
    transform: "translate(1.716 1.735)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 39300",
    d: "M178.965 164.5v3.294a1.038 1.038 0 1 1-2.072 0v-6.561a1.038 1.038 0 1 1 2.072 0v3.268",
    transform: "translate(-162.921 -147.294)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 39301",
    d: "M173.067 101.541a1.382 1.382 0 0 1 1.389 1.428 1.4 1.4 0 0 1-2.8-.047 1.383 1.383 0 0 1 1.41-1.381",
    transform: "translate(-158.049 -92.77)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon_information.470cc9e5001a034e4fc1f0e9de850501.svg";
export { ForwardRef as ReactComponent };